import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { ServiceCardWrap, PageLinkWrapElem, PageLinkElem } from './ServiceCard.styles';

const ServiceCard = (props) => {
  const { name, services, onServiceClickCB, rigidHeight } = props;
  return (
    <ServiceCardWrap
      className={`bg-activity-sport-400 text-basic-700 rounded-2xl p-6 md:p-9 sm:h-full ${
        rigidHeight ? 'h-98per' : ''
      }`}
      rigidHeight={rigidHeight}
    >
      <h2 className="h3">{name}</h2>
      <ul className="py-6 md:py-8">
        {services.map((service) => (
          <PageLinkWrapElem key={service.id} className="font-bold py-rem375 md:py-3 leading-8 md:leading-5">
            <Link href="/[...slug]" as={service.url} passHref>
              <PageLinkElem onClick={() => onServiceClickCB(name, service.title)}>{service.title}</PageLinkElem>
            </Link>
          </PageLinkWrapElem>
        ))}
      </ul>
    </ServiceCardWrap>
  );
};

ServiceCard.defaultProps = {
  onServiceClickCB: () => {},
  rigidHeight: false,
};

ServiceCard.propTypes = {
  name: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  onServiceClickCB: PropTypes.func,
  rigidHeight: PropTypes.bool,
};

ServiceCard.defaultProps = {
  services: [],
};

export default ServiceCard;
